"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "user"
            ]);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/LearningPath/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Header_Learner_template = require("../../components/Header-Learner.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Header_Learner_tag = marko_loadTag(Header_Learner_template),
    Accordion_template = require("./components/Accordion.marko"),
    Accordion_tag = marko_loadTag(Accordion_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Wrapper_template = require("../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "content-body pb-4"
      },
    marko_attrs1 = {
        "class": "mt-4"
      },
    marko_attrs2 = {
        "class": "accordion collapse-icon accordion-icon-rotate",
        "data-toggle-hover": "true"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("ed4fe0"),
    marko_node0 = marko_createElement("h5", {
        "class": "font-medium-4"
      }, "12", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Points"),
    marko_node1 = marko_createElement("ul", {
        "class": "list-inline"
      }, "13", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("li", {
          "class": "mr-4"
        }, null, null, 2)
        .e("span", {
            "class": "text-primary"
          }, null, null, 1)
          .t("5600")
        .t(" Total")
      .e("li", {
          "class": "mr-4"
        }, null, null, 2)
        .e("span", {
            "class": "text-primary"
          }, null, null, 1)
          .t("2460")
        .t(" Acquired"),
    marko_node2 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("h5", {
        "class": "font-medium-4"
      }, "19", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Certificate"),
    marko_node4 = marko_createElement("ul", {
        "class": "list-inline"
      }, "20", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("li", {
          "class": "mr-4"
        }, null, null, 2)
        .e("span", {
            "class": "text-primary"
          }, null, null, 1)
          .t("30")
        .t(" Total")
      .e("li", {
          "class": "mr-4"
        }, null, null, 2)
        .e("span", {
            "class": "text-primary"
          }, null, null, 1)
          .t("17")
        .t(" Received"),
    marko_node5 = marko_createElement("br", null, "25", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node6 = marko_createElement("h5", {
        "class": "font-medium-4"
      }, "26", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Instructors"),
    marko_node7 = marko_createElement("div", {
        "class": "mt-6"
      }, "27", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("ul", {
          "class": "list-unstyled users-list m-0 d-flex align-items-center"
        }, null, null, 6)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Alain Krich"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-15.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Berson Delano"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-25.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Xiona Peace"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-20.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Menlona Ivlaskiv"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-10.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Profile",
              "data-container": "#A-switch",
              "data-profile-id": "userID",
              title: "Tolla Nkombi"
            }, null, null, 1)
            .e("img", {
                "class": "media-object rounded-circle",
                src: "/images/portrait/small/avatar-s-23.jpg",
                alt: "Avatar",
                height: "44",
                width: "44"
              }, null, null, 0)
        .e("li", {
            "class": "avatar pull-up my-0"
          }, null, null, 1)
          .e("a", {
              "data-render": "Mates",
              "data-container": "#A-switch",
              "data-class-id": "classID",
              "class": "center-align",
              title: "See All"
            }, null, null, 1)
            .e("i", {
                "class": "bx bx-dots-horizontal-rounded grey lighten-2 rounded-circle font-medium-5",
                style: "padding:10px;"
              }, null, null, 0),
    marko_node8 = marko_createElement("br", null, "47", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node9 = marko_createElement("br", null, "48", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      class: "pl-5 pr-3",
      scroll: true,
      renderBody: function(out) {
        Header_Learner_tag({
            intro: "Good day",
            concern: state.user.first_name + "!",
            assessment: {
                icon: "bx bxs-smile",
                subject: "You're making good progress"
              },
            ranking: {}
          }, out, __component, "1");

        out.be("div", marko_attrs0, "2", component);

        out.be("section", marko_attrs1, "3", component);

        Row_tag({
            renderBody: function(out) {
              WSAdapt_tag({
                  ns: "col-lg-7",
                  qs: "col-lg-9",
                  hs: "col-lg-12",
                  renderBody: function(out) {
                    out.be("div", marko_attrs2, "6", component);

                    Accordion_tag({
                        completed: true
                      }, out, __component, "7");

                    Accordion_tag({
                        completed: true
                      }, out, __component, "8");

                    Accordion_tag({
                        completed: false
                      }, out, __component, "9");

                    Accordion_tag({
                        completed: false
                      }, out, __component, "10");

                    out.ee();
                  }
                }, out, __component, "5");

              WSAdapt_tag({
                  ns: "col-lg-5",
                  qs: "col-lg-3",
                  hs: "d-none",
                  class: "px-4",
                  renderBody: function(out) {
                    out.n(marko_node0, component);

                    out.n(marko_node1, component);

                    out.n(marko_node2, component);

                    out.n(marko_node3, component);

                    out.n(marko_node4, component);

                    out.n(marko_node5, component);

                    out.n(marko_node6, component);

                    out.n(marko_node7, component);

                    out.n(marko_node8, component);

                    out.n(marko_node9, component);
                  }
                }, out, __component, "11");
            }
          }, out, __component, "4");

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
